import React, { useState, useEffect } from 'react';
import styles from './Hero.module.css';
import ImgS1 from '../../assets/images/banner/vue-laterale-femmes-souriantes-recolte_23-2149894702.jpg';
import ImgS2 from '../../assets/images/banner/femme-africaine-recolte-legumes_23-2151441227.jpg';
import ImgS3 from '../../assets/images/banner/femme-grand-angle-tenant-carottes_23-2149894670.jpg';

const Hero = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      background: `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url(${ImgS1}) center/cover`,
      title: 'Des produits agricoles frais et naturels',
      text: 'Découvrez notre sélection de fruits et légumes cultivés avec soin par nos agriculteurs locaux',
      button: 'Acheter maintenant',
    },
    {
      background: `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url(${ImgS2}) center/cover`,
      title: 'Livraison rapide à domicile',
      text: 'Recevez vos produits frais directement chez vous en 24h',
      button: 'Découvrir nos offres',
    },
    {
      background: `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url(${ImgS3}) center/cover`,
      title: 'Promotions exceptionnelles',
      text: 'Profitez de réductions sur nos meilleurs produits de saison',
      button: 'Voir les promotions',
    },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [slides.length]);

  const handleDotClick = (index) => {
    setCurrentSlide(index);
  };

  return (
    <section className={styles.hero}>
      <div className={styles.carousel}>
        {slides.map((slide, index) => (
          <div
            key={index}
            className={`${styles.carouselSlide} ${index === currentSlide ? styles.active : ''}`}
            style={{ background: slide.background }}
          >
            <div className={styles.carouselContent}>
              <h2>{slide.title}</h2>
              <p>{slide.text}</p>
              <a href="#" className={styles.carouselBtn}>{slide.button}</a>
            </div>
          </div>
        ))}
        <div className={styles.carouselControls}>
          {slides.map((_, index) => (
            <div
              key={index}
              className={`${styles.carouselDot} ${index === currentSlide ? styles.active : ''}`}
              onClick={() => handleDotClick(index)}
            ></div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Hero;
